// extracted by mini-css-extract-plugin
module.exports = {"suffix":"styles_suffix__IS4zv"};